import TextInput from './text-input';
import CurrencyInput from './currency-input';
import EmailInput from './email-input';
import PhoneInput from './phone-input';
import UrlInput from './url-input';
import AddressInput from './address-input';
import NumberInput from './number-input';
import TextArea from './text-area';
export { TextInput, CurrencyInput, EmailInput, PhoneInput, UrlInput, AddressInput, NumberInput, TextArea };